import React from 'react';
import PropTypes from 'prop-types';
// Models
import mProduct from 'models/product';
import mProfile from 'models/profile';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';

const ProfileFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const { name, product } = filters;

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('name') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.name"
              value={name.value}
              onChange={(value) => onFilterFieldChange('name', value)}
            />
          </div>
        )}
        {isFieldDisplayable('product') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.product"
              value={product.value}
              items={mProduct.configurationList}
              onChange={(value) => onFilterFieldChange('product', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

ProfileFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    name: listFilterShape,
    product: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mProfile.listFeatures.searchFields)(ProfileFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/assets/main/ProfileFilters.js